module.exports = __webpack_public_path__ + "static/media/33a Stand Up.d0f79d99.jpg";